import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const setCommerceCloudCartProduct = {
  name: "setCommerceCloudCartProduct" as const,
  input: z.object({
    integrationId: commerceCloudIntegrationId,
    productId: z.string().min(1),
  }),
  output: z.null(),
};
